export default __webpack_public_path__ + "static/media/verification.2a14c86c.png";